import styled from 'styled-components'

type StyledProps = {
  isOver?: boolean
}

const StyledCalendarWeekRowSlot = styled.div<StyledProps>`
  position: relative;
  padding: 8px;
  display: grid;
  grid-gap: 8px;
  transition: 0.2s;
  align-content: start;
  background-color: ${({ isOver, theme }) =>
    isOver ? theme.color.brandLight : theme.color.background};

  .add-post-btn {
    background-color: ${({ theme }) => theme.color.background};
    color: ${({ theme }) => theme.color.gray[500]};
    box-shadow: inset 0 0 0 1px rgb(255, 255, 255, 0.1), 0px 0px 0px 1px rgba(0, 0, 0, 0.05),
      0px 2px 3px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 0;
    border-radius: 5px;
    opacity: 0;
    transition: 0.2s;
    position: sticky;
    top: 8px;

    svg {
      height: 22px;
      stroke-width: 1.75px;
    }

    &:hover {
      cursor: pointer;
      box-shadow: inset 0 0 0 1px rgb(255, 255, 255, 0.2), 0px 0px 0px 1px rgba(0, 0, 0, 0.075),
        0px 2px 3px rgba(0, 0, 0, 0.1);
    }
  }

  &:hover {
    button {
      opacity: 1;
    }
  }

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.color.gray[200]};
  }
`

export default StyledCalendarWeekRowSlot
